import type { components } from "@jbnl/api-client";

export type Me = components["schemas"]["MeResponse"];

/**
 * Two separate grants, neither implying the other (ADR-0022), and most people hold exactly one.
 * Read here rather than per screen: a copy that fell behind shows a menu entry that refuses.
 */
export function toegang(me: Me) {
  const ploegen = me.korpsen.length > 0;

  // §4.3.1: nothing may be offered without a bevoegdheid, so a beschikbaarheidsscherm for
  // somebody who holds none could only ever tell them so. The flag is standing rather than
  // seizoensgebonden - see MeResponse.
  const ondersteuner = me.hasBevoegdheid;

  return {
    ploegen,
    ondersteuner,
    /** Neither. Signed in, and nothing here is theirs yet. */
    geen: !ploegen && !ondersteuner,
  };
}

/** The screens the front door can lead to, and where each of them lives. */
export const BESTEMMINGEN = {
  ploegen: "/ploegen",
  beschikbaarheid: "/beschikbaarheid",
  planning: "/planning",
} as const;

export type Bestemming = keyof typeof BESTEMMINGEN;

/**
 * Answered once: the front door reads it forwards and "terug naar overzicht" backwards, so a copy
 * that fell behind left the block screens with no way out.
 * @param heeftPlanning Passed in, because this is a pure reading of a session.
 */
export function bestemmingen(me: Me, heeftPlanning: boolean) {
  const heeft = toegang(me);

  const lijst: Bestemming[] = [];

  if (heeft.ploegen) lijst.push("ploegen");
  if (heeft.ondersteuner) lijst.push("beschikbaarheid");
  if (heeftPlanning) lijst.push("planning");

  return {
    /** Exactly the cards to draw - never a half this session does not hold. */
    lijst,

    /** Never sent on: the front door is where they are told what is missing. */
    geen: heeft.geen,

    /** Where `/` should send them instead of drawing itself, or null when it should draw. */
    doorsturen:
      !heeft.geen && lijst.length === 1 ? BESTEMMINGEN[lijst[0]] : null,
  };
}
